<scaffold-dialog [fit]="true" title="Select Integration to Use">
    <div scaffoldDialogBody>
        <div style="width: 650px;">
        <div class="align-center fa-2x" *ngIf="loading">
            <scaffold-loading-animation></scaffold-loading-animation>
        </div>
        <div *ngIf="integrations && integrations.length > 0">
            <div style="width: 100%; margin-bottom: 15px;" *ngIf="integrations.length > 4">
                <input pInputText fluid placeholder="Filter Integrations" [(ngModel)]="filterText" (ngModelChange)="filterIntegrations()" />
            </div>
            <div class="integration-select-container" *ngFor="let integration of filteredIntegrations">
                <scaffold-integration-banner [integration]="integration" (click)="selectIntegration(integration)" [selected]="selectedIntegration.includes(integration)" [syncDetails]="true" [showInfoIcon]="true"></scaffold-integration-banner>
                
            </div>
            <div *ngIf="integrations.length > 0 && filteredIntegrations.length === 0" style="width: 535px;" class="align-center">
                <label>{{'no_integrations_match_filter' | translation | translationFromString | transformText :'capitalize'}}</label>
            </div>
        </div>
        <div *ngIf="integrations && integrations.length === 0 && !loading" style="width: 535px;" class="align-center">
            <label>{{ getNoIntegrationMessage() | translation |translationFromString  | transformText :'capitalize'}} </label>
        </div>
    </div>
</div>
    <div scaffoldDialogButtons>    
        <button pButton variant="outlined" severity="secondary" (click)="closeDialog()">Cancel</button>
        <p-buttongroup *ngIf="selectedIntegration[0]?.has_course">
            <button pButton severity="primary" [disabled]="!selectedIntegration || selectedIntegration.length === 0" (click)="select(true)"
            pTooltip="If this course has previously been synced, this will create a new copy of the course instead of updating the existing one.">Sync As New Course</button>
            <button pButton severity="primary" [disabled]="!selectedIntegration || selectedIntegration.length === 0" (click)="select(false)">Sync Selected</button>
        </p-buttongroup>
        <button *ngIf="!selectedIntegration[0]?.has_course" pButton severity="primary" [disabled]="!selectedIntegration || selectedIntegration.length === 0" (click)="select(false)">Sync Selected</button>
    </div>
  </scaffold-dialog>
  